import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { getFullComposeViewState } from 'owa-calendar-compose-store-manager';
import expressionStore from 'owa-expressions-store/lib/store/expressionStore';
import SidePaneType from 'owa-calendar-sidepane/lib/schema/SidePaneType';
import SidePane from 'owa-calendar-sidepane/lib/component/SidePane';
import loc from 'owa-localize';
import { expressionsHeader } from './FullComposeSidePane.locstring.json';
import toggleEmojiPicker from '../../utils/toggleEmojiPicker';
import { ExpressionPane } from 'owa-expressions-view';

const styles = require('./FullComposeSidePane.scss');
const classNames = require('classnames/bind').bind(styles);

export interface FullComposeExpressionPaneProps {
    formId: string | null;
}

const FullComposeExpressionPane: React.FunctionComponent<FullComposeExpressionPaneProps> = props => {
    const { formId } = props;

    const { currentSidePaneType, expressionId } = getFullComposeViewState(formId);

    const isOpened =
        expressionStore.expressionPickerViewStates.get(expressionId) &&
        currentSidePaneType == SidePaneType.EmojiPicker;

    return (
        <SidePane title={loc(expressionsHeader)} isOpened={isOpened} onClose={toggleEmojiPicker}>
            <div className={classNames(styles.sidePane, styles.expressionPane, 'customScrollBar')}>
                <ExpressionPane expressionId={expressionId} />
            </div>
        </SidePane>
    );
};

export default observer(FullComposeExpressionPane);
